function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { OrderItem } from 'swag-client-common/components/partials/cart/cart-item';
import { DesignUploadMode } from 'swag-common/interfaces';
import { checkIsMoreThanOneItemWithSimilarKey } from 'swag-common/utils/items/is-more-than-one-item-with-similar-key.util';
import { hasSplitShippedToInventory } from 'swag-common/utils/items/has-split-shipped-to-inventory';
import { getImageOfItem, isItemSizeEditable } from '../../../../../../redux/cart/cart.utils';
import { isRenderAsInventoryItems } from '../../../../../../redux/cart/order-item-list.utils-other';
import BoxOrderItemList from '../box-order-item-list';
import { InventoryOrderItemList } from '../inventory-order-item-list';
import ItemsBlockWrapper from '../items-block-wrapper';
import RelatedOrderItemList from '../related-order-item-list';
import { getItemQuantClasses, getTitleClasses } from './get-classes';
import { getProps } from './get-wrapper-props/get-props';
import classes from './saved-for-later-list.scss';
const SavedForLaterList = ({
  items,
  itemsCount,
  isLoading,
  selectedItem,
  onMoveToCart,
  onRemoveItem,
  onEditRequest,
  onSizeClick,
  onEditSizeOfSample,
  onClickMockup,
  onShareClick,
  onProductionTimeClick,
  onQuantityClick,
  onProductionTimeChange
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.orderItem,
  id: "draft"
}, /*#__PURE__*/React.createElement("h5", {
  className: getTitleClasses()
}, "Saved for later", /*#__PURE__*/React.createElement("span", {
  className: getItemQuantClasses(),
  "data-text": "DraftItemsCount"
}, "(", `${itemsCount}`, " ", itemsCount === 1 ? 'item' : 'items', ")")), items.map((item, index) => {
  var _item$0$prod;
  const isArray = Array.isArray(item);
  const isRelated = isArray && checkIsMoreThanOneItemWithSimilarKey(item, 'asRelatedItemId');
  const isBox = isArray && checkIsMoreThanOneItemWithSimilarKey(item, 'boxItemsId');
  const isToInventory = isRenderAsInventoryItems(isBox, item);
  const isSplitShippedToInventory = hasSplitShippedToInventory(item);
  if (isToInventory || isSplitShippedToInventory) {
    return /*#__PURE__*/React.createElement(InventoryOrderItemList, {
      items: item,
      key: item[0]._id,
      isLoading: isLoading,
      isSavedForLater: true,
      onMoveToCart: onMoveToCart,
      selectedItem: selectedItem,
      onSizeClick: onSizeClick,
      onRemoveItem: onRemoveItem,
      onShareClick: onShareClick,
      onClickMockup: onClickMockup,
      onEditRequest: onEditRequest,
      onQuantityClick: onQuantityClick,
      onEditSizeOfSample: onEditSizeOfSample,
      onProductionTimeClick: onProductionTimeClick,
      onProductionTimeChange: onProductionTimeChange
    });
  }
  if (isBox) {
    return /*#__PURE__*/React.createElement(ItemsBlockWrapper, getProps(items.length, index), /*#__PURE__*/React.createElement(BoxOrderItemList, {
      items: item,
      key: index,
      item: item[0],
      isLoading: isLoading,
      selectedItem: selectedItem,
      onSizeClick: onSizeClick,
      onRemoveItem: onRemoveItem,
      onShareClick: onShareClick,
      onMoveToCart: onMoveToCart,
      onClickMockup: onClickMockup,
      onEditRequest: onEditRequest,
      onQuantityClick: onQuantityClick,
      onEditSizeOfSample: onEditSizeOfSample,
      onProductionTimeClick: onProductionTimeClick,
      onProductionTimeChange: onProductionTimeChange,
      onSampleClick: () => ({}),
      isCart: false
    }));
  }
  if (isRelated) {
    return /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
      key: item[0]._id
    }, getProps(items.length, index)), /*#__PURE__*/React.createElement(RelatedOrderItemList, {
      items: item,
      isLoading: Boolean(isLoading),
      selectedItem: selectedItem,
      onSizeClick: onSizeClick,
      onRemoveItem: onRemoveItem,
      onShareClick: onShareClick,
      onMoveToCart: onMoveToCart,
      onClickMockup: onClickMockup,
      onEditRequest: onEditRequest,
      onQuantityClick: onQuantityClick,
      onEditSizeOfSample: onEditSizeOfSample,
      onProductionTimeClick: onProductionTimeClick,
      onProductionTimeChange: onProductionTimeChange,
      isCart: false
    }));
  }
  const designUploadMode = (_item$0$prod = item[0].prod) === null || _item$0$prod === void 0 ? void 0 : _item$0$prod.designUploadMode;
  return item.map(i => {
    const isPlainCard = item.length === 1;
    return /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
      key: item[0]._id,
      isPlainCard: isPlainCard
    }, getProps(items.length, index)), /*#__PURE__*/React.createElement(OrderItem, {
      index: index,
      item: i,
      selectedItem: selectedItem,
      itemLogoSrc: getImageOfItem(i),
      isSizeEditable: isItemSizeEditable(i),
      isFullDesign: designUploadMode === DesignUploadMode.fullDesign,
      isBoxProduct: designUploadMode === DesignUploadMode.box,
      isSavedForLater: true,
      isPlainCard: isPlainCard,
      removeItem: onRemoveItem,
      onSizeClick: onSizeClick,
      moveToCart: onMoveToCart,
      onShareClick: onShareClick,
      onClickMockup: onClickMockup,
      onEditRequest: onEditRequest,
      onQuantityClick: onQuantityClick,
      onEditSizeOfSample: onEditSizeOfSample,
      onProductionTimeClick: onProductionTimeClick,
      onProductionTimeChange: onProductionTimeChange
    }));
  });
}));
export { SavedForLaterList };